<template>
    <div class="operations" :class="statsPaneSize < 1 ? 'panel-show' : 'panel-hide'">
        <splitpanes class="default-theme" :dbl-click-splitter="false" horizontal @splitter-click="togglePane"
                    @resize="statsPaneSize = $event[1].size">
            <pane :size="100 - statsPaneSize">
                <splitpanes class="default-theme" :dbl-click-splitter="false" :horizontal="is_col_12"
                            @resize="paneSize = $event[1].size">
                    <pane :size="100 - paneSize" min-size="35">
                        <div style="position: relative; height: 100%" @mouseover="focusOne = true"
                             @mouseleave="focusOne = false">
                            <div style="position: absolute; z-index: 2; left: 30px" :style="{'top': top_px}">
                                <div class="row justify-content-center">
                                    <AppGoogleMapsTypeControl :show_first_row="false" ref="googleMapsTypeControlOne"
                                                                  @handleMapControlClick="handleMapControlClickOne">
                                    </AppGoogleMapsTypeControl>
                                </div>
                            </div>
                            <div :style="{'top': is_col_12 ? '110px' : '90px'}"
                                 style="position: absolute; z-index: 1; left: 20px">
                                <AppOperationsWorkOptions :rate_steps="rateStepsOne" :map-type="mapTypeOne"
                                                             @changeVisibility="changeVisibility($event, tilesDataOne, opacityOne, 'one')"
                                                             @changeColorPalette="changeColorPalette($event, 'one')"
                                                             @edit="editScale(rateStepsOne, 'one')" ref="operationsWorkOptionsOne"/>
                            </div>
                            <AppGoogleMapsOperations ref="googleMapsOperationOne" :loading="loadingTilesOne"
                                                        :position_center="operationMapCenterOne" :selected_field="selectedField"
                                                        :google_maps_operations_id="'compare-tasks-1'"
                                                        :focused="focusOne" :tiles-data="tilesDataOne"
                                                        @boundsChanged="updateBoundsTwo"/>
                        </div>
                    </pane>
                    <pane :size="paneSize" min-size="35">
                        <div style="position: relative; height: 100%" @mouseover="focusTwo = true"
                             @mouseleave="focusTwo = false">
                            <div style="position: absolute; z-index: 2; left: 30px" :style="{'top': top_px}">
                                <div class="row justify-content-center">
                                    <AppGoogleMapsTypeControl :show_first_row="false" ref="googleMapsTypeControlTwo"
                                                                  @handleMapControlClick="handleMapControlClickTwo">
                                    </AppGoogleMapsTypeControl>
                                </div>
                            </div>
                            <div :style="{'top': is_col_12 ? '110px' : '90px'}" style="position: absolute; z-index: 1; left: 20px">
                                <AppOperationsWorkOptions :rate_steps="rateStepsTwo" :map-type="mapTypeTwo"
                                                             @changeVisibility="changeVisibility($event, tilesDataTwo, opacityTwo, 'two')"
                                                             @changeColorPalette="changeColorPalette($event, 'two')"
                                                             @edit="editScale(rateStepsTwo, 'two')" ref="operationsWorkOptionsTwo"/>
                            </div>
                            <AppGoogleMapsOperations ref="googleMapsOperationTwo" :loading="loadingTilesTwo"
                                                        :position_center="operationMapCenterOne" :selected_field="selectedField"
                                                        :google_maps_operations_id="'compare-tasks-2'"
                                                        :focused="focusTwo" :tiles-data="tilesDataTwo"
                                                        @boundsChanged="updateBoundsOne"/>
                        </div>
                    </pane>
                </splitpanes>
            </pane>
            <pane :size="statsPaneSize" max-size="70" class="stats">
                <div class="d-flex">
                    <div :style="{width: (100 - paneSize) + '%'}">
                        <AppOperationsStatsSkeleton v-if="loadingStatisticsOne" :stats="statisticsOne" :operators="operatorsOne" :varieties="varietiesOne"
                                            :operation="operationOne" :vehicles="vehiclesOne" :products="productsOne"
                                            :pane_size="30"/>

                        <AppOperationsStats v-else :stats="statisticsOne" :operators="operatorsOne" :varieties="varietiesOne"
                                              :operation="operationOne" :vehicles="vehiclesOne" :products="productsOne"
                                              :pane_size="30"/>
                    </div>
                    <div :style="{width: paneSize + '%'}">
                        <AppOperationsStatsSkeleton v-if="loadingStatisticsTwo" :stats="statisticsTwo" :operators="operatorsTwo" :varieties="varietiesTwo"
                                      :operation="operationTwo" :vehicles="vehiclesTwo" :products="productsTwo"
                                      :pane_size="30"/>

                        <AppOperationsStats v-else :stats="statisticsTwo" :operators="operatorsTwo" :varieties="varietiesTwo"
                                              :operation="operationTwo" :vehicles="vehiclesTwo" :products="productsTwo"
                                              :pane_size="30"/>
                    </div>
                </div>
            </pane>
        </splitpanes>

        <AppOperationsRateStepsEditDialog :show_edit_dialog="showEditDialog" :rate_steps="rateStepsEdit"
                                               :original-rate-steps="originalRateSteps" :min_value="minValue"
                                               :opacity="opacity" @applyNewScale="applyNewScale"
                                               @hideDialog="closeDialog"/>
    </div>
</template>

<script>

import 'splitpanes/dist/splitpanes.css'
import {Pane, Splitpanes} from 'splitpanes'

import buildColorRange from "@/mixins/ColorMixin";
import hexToRgb from "@/mixins/ColorMixin";
import getUserColorsSet from "@/mixins/ColorMixin";
import buildColorBounds from "@/mixins/ColorMixin";
import formatPercent from "@/mixins/ValuesFormat";
import buildStatistics from "@/utils/OperationsStatisticsBuilder";

import AppGoogleMapsOperations from "./AppGoogleMapsOperations";
import AppGoogleMapsTypeControl from "@/components/common/AppGoogleMapsTypeControl";
import AppOperationsWorkOptions from "../operation-scale/AppOperationsWorkOptions.vue";
import AppOperationsStats from "../operation-statistics/AppOperationsStats.vue";
import AppOperationsStatsSkeleton from "../operation-statistics/AppOperationsStatsSkeleton.vue";
import AppOperationsRateStepsEditDialog from "../operation-scale/AppOperationsRateStepsEditDialog.vue";

import {MAP_TYPES} from "../AppAgricultureOptions";
import {MAPS_OVERLAY_OPEN_WEATHER_TYPES, MAPS_OVERLAY_WEATHER_TYPES} from "../../real-time/AppOptions";

import OperationsService from "@/services/OperationsService";

export default {
    mixins: [buildColorRange, hexToRgb, formatPercent, buildStatistics, getUserColorsSet, buildColorBounds],
    beforeMount() {
        this.operationsService = new OperationsService();
        this.is_col_12 = this.isScreenMobile;
        this.top_px = this.isScreenMobile ? '50px' : '30px';
    },
    mounted() {
        this.operationMapCenterOne = this.fieldCenter;
        this.getStatistics(this.operationOne, 'one')
        this.getStatistics(this.operationTwo, 'two')
    },
    data() {
        return {
            operationsService: null,
            is_col_12: false,
            top_px: '',
            tilesDataOne: {
                requestId: null,
                zooms: [],
                grouped: false,
                color_bounds: [],
                center_tile: false,
                center: {},
                bounds: []
            },
            tilesDataTwo: {
                requestId: null,
                zooms: [],
                grouped: false,
                color_bounds: [],
                center_tile: false,
                center: {},
                bounds: []
            },
            operationMapCenterOne: {},
            operationMapCenterTwo: {},
            operationMapBoundsOne: [],
            operationMapBoundsTwo: [],
            originalRateStepsOne: [],
            originalRateStepsTwo: [],
            rateStepsOne: [],
            rateStepsTwo: [],
            originalRateSteps: [],
            rateStepsEdit: [],
            tilesZoomsOne: [],
            tilesZoomsTwo: [],
            loadingTilesOne: false,
            loadingTilesTwo: false,
            focusOne: false,
            focusTwo: false,
            requestIdOne: null,
            requestIdTwo: null,
            layerColorBoundsOne: [],
            layerColorBoundsTwo: [],
            opacity: 75,
            opacityOne: 75,
            opacityTwo: 75,
            minValue: 0,
            minValueOne: 0,
            minValueTwo: 0,
            showEditDialog: false,
            scaleEdit: null,
            statisticsOne: {},
            operatorsOne: [],
            vehiclesOne: [],
            varietiesOne: [],
            productsOne: [],
            statisticsTwo: {},
            operatorsTwo: [],
            vehiclesTwo: [],
            varietiesTwo: [],
            productsTwo: [],
            paneSize: 50,
            statsPaneSize: 35,
            centerMap: true,
            previousMapEmptyOne: true,
            loadingStatisticsOne: true,
            loadingStatisticsTwo: true
        }
    },
    methods: {
        togglePane() {
            if (this.statsPaneSize > 1) {
                this.statsPaneSize = 0
                return
            }

            this.statsPaneSize = 35
        },
        updateBoundsTwo(boundsOne) {
            this.$refs.googleMapsOperationTwo.updatePosition(boundsOne.zoom, boundsOne.center)
        },
        updateBoundsOne(boundsTwo) {
            this.$refs.googleMapsOperationOne.updatePosition(boundsTwo.zoom, boundsTwo.center)
        },
        handleMapControlClickOne(val) {
            this.handleMapControlClick(val, 'googleMapsOperationOne')
        },
        handleMapControlClickTwo(val) {
            this.handleMapControlClick(val, 'googleMapsOperationTwo')
        },
        handleMapControlClick(val, ref) {
            switch (val) {
                case 'roadmap':
                    this.$refs[ref].setUpMapType('roadmap');
                    break;
                case 'hybrid':
                    this.$refs[ref].setUpMapType('hybrid');
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.PRECIPITATION:
                    this.$refs[ref].setupWeatherOverlay(MAPS_OVERLAY_OPEN_WEATHER_TYPES.PRECIPITATION);
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.TEMPERATURE:
                    this.$refs[ref].setupWeatherOverlay(MAPS_OVERLAY_OPEN_WEATHER_TYPES.TEMPERATURE);
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.CLOUDS:
                    this.$refs[ref].setupWeatherOverlay(MAPS_OVERLAY_OPEN_WEATHER_TYPES.CLOUDS);
                    break;
                case MAPS_OVERLAY_WEATHER_TYPES.REMOVE:
                    this.$refs[ref].setupWeatherOverlay(MAPS_OVERLAY_WEATHER_TYPES.REMOVE);
                    break;
                default:
            }
        },
        changeVisibility(scaleSteps, tilesData, opacity, map) {
            let tmpTilesData = JSON.parse(JSON.stringify(tilesData))
            let tmpColors = tmpTilesData.color_bounds

            tmpColors.forEach(bound => {
                let boundFound = scaleSteps.find(step => step.value === this.getBoundFromValue(bound.upper, map))

                if (boundFound) {
                    bound.color = this.hexToRgb(boundFound.color, boundFound.visible ? opacity : 0)
                }
            })

            tmpTilesData.center_tile = false
            if (map === 'one') {
                this.tilesDataOne = tmpTilesData
                return
            }

            this.tilesDataTwo = tmpTilesData
        },
        changeColorPalette(rateSteps, map) {
            this.rateStepsEdit = JSON.parse(JSON.stringify(rateSteps))

            let newScale = []
            this.rateStepsEdit.forEach(step => {
                newScale.push(step.value)
            })

            if (map === 'one') {
                newScale.push(this.minValueOne)
                this.getScaleOne(newScale, this.requestIdOne)
                return
            }

            newScale.push(this.minValueTwo)
            this.getScaleTwo(newScale, this.requestIdTwo)
        },
        getBoundFromValue(upperBound, map) {
            let mapType = map === 'one' ? this.mapTypeOne : this.mapTypeTwo
            if (mapType.ddi === 'operator' || !mapType.grouped) {
                return upperBound
            }

            if (mapType.grouped) {
                if (mapType.ddi === 'date') {
                    return this.dateFormat(Number.parseInt(upperBound), 'GMT');
                }

                let vehicles = map === 'one' ? this.vehiclesOne : this.vehiclesOne
                if (mapType.ddi === 'vehicle') {
                    let foundVehicle = vehicles.find(vehicle => vehicle.id === upperBound)
                    return foundVehicle ? foundVehicle.display_name : '---'
                }
            }
        },
        editScale(rateSteps, map) {
            this.scaleEdit = map
            this.rateStepsEdit = JSON.parse(JSON.stringify(rateSteps))
            this.originalRateSteps = JSON.parse(JSON.stringify(map === 'one' ? this.originalRateStepsOne : this.originalRateStepsTwo))
            this.minValue = map === 'one' ? this.minValueOne : this.minValueTwo
            this.opacity = map === 'one' ? this.opacityOne : this.opacityTwo
            this.showEditDialog = true
        },
        closeDialog() {
            this.showEditDialog = false
        },
        getFileNameOne() {
            this.clearData('one')

            let config = {
                work_id: this.operationOne.id,
                ddi: this.mapTypeOne.ddi
            }

            this.loadingTilesOne = true;

            this.operationsService.configMbtilesRaster(config)
                .then(response => {
                    this.previousMapEmptyOne = false;
                    this.tilesZoomsOne = response.zooms;
                    this.requestIdOne = response.request_id;
                    this.operationMapCenterOne = response.center;
                    this.operationMapBoundsOne = response.bounds;
                    this.getScaleOne(null, this.requestIdOne);
                })
                .catch(error => {
                    this.previousMapEmptyOne = true;
                    this.loadingTilesOne = false;
                    this.operationMapCenterOne = {};
                    this.operationMapBoundsOne = [];
                    if (error.response && error.response.status === 404) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperationsCompare.Erro'),
                            detail: this.$t('AppOperationsCompare.Não há dados para gerar o mapa desta operação'),
                            life: 5000
                        });
                        return
                    }

                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsCompare.Erro'),
                        detail: this.$t('AppOperationsCompare.Houve um erro ao recuperar as informações, Tente novamente'),
                        life: 5000
                    });
                })
        },
        getFileNameTwo() {
            this.clearData('two')

            let config = {
                work_id: this.operationTwo.id,
                ddi: this.mapTypeTwo.ddi
            }

            this.loadingTilesTwo = true;

            this.operationsService.configMbtilesRaster(config)
                .then(response => {
                    this.tilesZoomsTwo = response.zooms;
                    this.requestIdTwo = response.request_id;
                    this.operationMapCenterTwo = response.center;
                    this.operationMapBoundsTwo = response.bounds;
                    this.getScaleTwo(null, this.requestIdTwo);
                })
                .catch(error => {
                    this.loadingTilesTwo = false;
                    this.operationMapCenterTwo = {};
                    this.operationMapBoundsTwo = [];
                    if (error.response && error.response.status === 404) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppOperationsCompare.Erro'),
                            detail: this.$t('AppOperationsCompare.Não há dados para gerar o mapa desta operação'),
                            life: 5000
                        });
                        return
                    }

                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsCompare.Erro'),
                        detail: this.$t('AppOperationsCompare.Houve um erro ao recuperar as informações, Tente novamente'),
                        life: 5000
                    });
                })
        },
        getScaleOne(scaleLimits, requestId) {
            let params = this.configParams(scaleLimits);
            this.loadingTilesOne = true;
            this.operationsService.getInitialState(requestId, params)
                .then(response => {
                    this.layerColorBoundsOne = response.colors;
                    this.processStepRateOne(response.colors.length, scaleLimits);
                    this.showEditDialog = false;
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsCompare.Erro'),
                        detail: this.$t('AppOperationsCompare.Não foi possível carregar o mapa'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingTilesOne = false;
                })
        },
        getScaleTwo(scaleLimits, requestId) {
            let params = this.configParams(scaleLimits);
            this.loadingTilesTwo = true;
            this.operationsService.getInitialState(requestId, params)
                .then(response => {
                    this.layerColorBoundsTwo = response.colors;
                    this.processStepRateTwo(response.colors.length, scaleLimits);
                    this.showEditDialog = false;
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsCompare.Erro'),
                        detail: this.$t('AppOperationsCompare.Não foi possível carregar o mapa'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loadingTilesTwo = false;
                })
        },
        configParams(scaleLimits) {
            if (!scaleLimits) {
                return null
            }

            return {
                num_quantile: scaleLimits.length - 1,
                bounds: JSON.stringify(scaleLimits)
            }
        },
        processStepRateOne(steps, scaleLimits) {
            let rateStepsTemp = [];
            this.layerColorBoundsOne = this.sortLayerColorBounds(this.mapTypeOne, this.layerColorBoundsOne)
            let COLORS_ONE = scaleLimits ? this.getUserColorsSet(this.rateStepsEdit) : this.setColorRange(this.mapTypeOne, steps)

            for (const index in this.layerColorBoundsOne) {
                rateStepsTemp.push({
                    value: this.parseValue(this.mapTypeOne, this.layerColorBoundsOne, index, this.vehiclesOne),
                    color: COLORS_ONE[index],
                    percentage: this.formatPercent(this.layerColorBoundsOne[index].area.percent),
                    visible: true,
                    invalid: false
                })
            }

            if (!this.mapTypeOne.grouped) {
                this.minValueOne = this.layerColorBoundsOne[this.layerColorBoundsOne.length - 1].bound.lower
            }
            this.rateStepsOne = rateStepsTemp;
            if (scaleLimits === null) {
                this.originalRateStepsOne = JSON.parse(JSON.stringify(rateStepsTemp))
            }
            let fOne = this.focusOne
            this.focusOne = true
            this.tilesDataOne = {
                requestId: this.requestIdOne,
                zooms: this.tilesZoomsOne,
                grouped: this.mapTypeOne.grouped,
                color_bounds: this.buildColorBounds(this.layerColorBoundsOne, COLORS_ONE, this.opacityOne),
                center_tile: this.centerMap,
                center: this.getMapCenter(),
                bounds: this.getMapBounds()
            }
            setTimeout(() => this.focusOne = fOne, 100)
        },
        processStepRateTwo(steps, scaleLimits) {
            let rateStepsTemp = [];
            this.layerColorBoundsTwo = this.sortLayerColorBounds(this.mapTypeTwo, this.layerColorBoundsTwo)
            let COLORS_TWO = scaleLimits ? this.getUserColorsSet(this.rateStepsEdit) : this.setColorRange(this.mapTypeTwo, steps)

            for (const index in this.layerColorBoundsTwo) {
                rateStepsTemp.push({
                    value: this.parseValue(this.mapTypeTwo, this.layerColorBoundsTwo, index, this.vehiclesTwo),
                    color: COLORS_TWO[index],
                    percentage: this.formatPercent(this.layerColorBoundsTwo[index].area.percent),
                    visible: true,
                    invalid: false
                })
            }

            if (!this.mapTypeTwo.grouped) {
                this.minValueTwo = this.layerColorBoundsTwo[this.layerColorBoundsTwo.length - 1].bound.lower
            }
            this.rateStepsTwo = rateStepsTemp;
            if (scaleLimits === null) {
                this.originalRateStepsTwo = JSON.parse(JSON.stringify(rateStepsTemp))
            }
            let fTwo = this.focusTwo
            this.focusTwo = true
            this.tilesDataTwo = {
                requestId: this.requestIdTwo,
                zooms: this.tilesZoomsTwo,
                grouped: this.mapTypeTwo.grouped,
                color_bounds: this.buildColorBounds(this.layerColorBoundsTwo, COLORS_TWO, this.opacityTwo),
                center_tile: this.centerMap,
                center: this.getMapCenter(),
                bounds: this.getMapBounds()
            }
            setTimeout(() => this.focusTwo = fTwo, 100)
        },
        getMapCenter() {
            return JSON.stringify(this.operationMapCenterOne) === '{}' ? this.operationMapCenterTwo : this.operationMapCenterOne
        },
        getMapBounds() {
            return JSON.stringify(this.operationMapBoundsOne) === '[]' ? this.operationMapBoundsTwo : this.operationMapBoundsOne
        },
        sortLayerColorBounds(mapType, layerColorBounds) {
            if (mapType.grouped && mapType.ddi !== 'date') {
                return layerColorBounds.sort((a, b) => a.bound.upper.localeCompare(b.bound.upper))
            }

            return layerColorBounds.sort((a, b) => b.bound.upper - a.bound.upper)
        },
        setColorRange(mapType, steps) {
            if (mapType.grouped) {
                return this.buildColorRange(steps, 0, 290)
            }
            return this.buildColorRange(steps)
        },
        parseValue(mapType, layerColorBounds, index, vehicles) {
            if (mapType.value === 'date') {
                return this.dateFormat(Number.parseInt(layerColorBounds[index].bound.upper), 'GMT')
            }

            if (mapType.value === 'vehicle') {
                let foundVehicle = vehicles.find(vehicle => vehicle.id === layerColorBounds[index].bound.upper)
                if (foundVehicle) {
                    return foundVehicle.display_name
                }

                return '---'
            }

            return layerColorBounds[index].bound.upper
        },
        applyNewScale(rateSteps, opacity) {
            this.rateStepsEdit = JSON.parse(JSON.stringify(rateSteps))

            let newScale = []
            this.rateStepsEdit.forEach(step => {
                newScale.push(step.value)
            })

            if (this.scaleEdit === 'one') {
                this.$refs.operationsWorkOptionsOne.changeGradient('custom')
                newScale.push(this.minValueOne)
                this.opacityOne = opacity
                this.getScaleOne(newScale, this.requestIdOne)
                return
            }

            this.$refs.operationsWorkOptionsTwo.changeGradient('custom')
            newScale.push(this.minValueTwo)
            this.opacityTwo = opacity
            this.getScaleTwo(newScale, this.requestIdTwo)
        },
        getStatistics(operation, map) {
            this.clearStatistics(map)
            map === 'one' ? this.loadingTilesOne = true : this.loadingTilesTwo = true
            switch (operation.operation_type) {
                case 'SEEDING':
                    this.getOperationStatistics(operation, 'seedingStatistics', map)
                    break
                case 'HARVEST':
                    this.getOperationStatistics(operation, 'harvestStatistics', map)
                    break
                case 'MOWING':
                    this.getOperationStatistics(operation, 'mowingStatistics', map)
                    break
                case 'TILLAGE':
                    this.getOperationStatistics(operation, 'tillageStatistics', map)
                    break
                case 'DRY_APPLICATION':
                    this.getOperationStatistics(operation, 'dryApplicationStatistics', map)
                    break
                case 'LIQUID_APPLICATION':
                    this.getOperationStatistics(operation, 'liquidApplicationStatistics', map)
                    break
                case 'TRANSPORT':
                    this.getOperationStatistics(operation, 'transportStatistics', map)
                    break
            }
        },
        getOperationStatistics(operation, endpoint, map) {
            map === 'one' ? this.loadingStatisticsOne = true : this.loadingStatisticsTwo = true;
            this.operationsService.getOperationStatistics(operation.id, endpoint)
                .then(response => {
                    this.parseStatistics(this.buildStatistics(response, operation.operation_type), map);
                    this.$emit(map === 'one'? 'setAvailableMapTypesOne' : 'setAvailableMapTypesTwo', this.parseTitles(operation, response.map_types));
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperationsCompare.Erro'),
                        detail: this.$t('AppOperationsCompare.Não foi possível recuperar as estatísticas desta operação'),
                        life: 5000
                    });
                    map === 'one' ? this.loadingTilesOne = false : this.loadingTilesTwo = false;
                }).finally(() => {
                    map === 'one' ? this.loadingStatisticsOne = false : this.loadingStatisticsTwo = false;
                })
        },
        clearData(map) {
            if (map === 'one') {
                this.tilesDataOne = {};
                this.rateStepsOne = [];
                return;
            }

            this.tilesDataTwo = {};
            this.rateStepsTwo = [];
        },
        clearStatistics(map) {
            if (map === 'one') {
                this.statisticsOne = {};
                this.operatorsOne = [];
                this.vehiclesOne = [];
                this.varietiesOne = [];
                this.productsOne = [];
                this.$emit('clearAvailableMapTypesOne');
                return;
            }

            this.statisticsTwo = {};
            this.operatorsTwo = [];
            this.vehiclesTwo = [];
            this.varietiesTwo = [];
            this.productsTwo = [];
            this.$emit('clearAvailableMapTypesTwo');
        },
        parseTitles(operation, mapTypes) {
            if (mapTypes.length === 0) {
                return this.loadStandardMapTypes(operation);
            }

            mapTypes.forEach(mapType => {
                mapType.title = this.$t(`AppAgricultureOptions.${mapType.title}`);
                if (mapType.ddi === '11' || mapType.ddi === '12') {
                    mapType.symbol = this.$t(`AppAgricultureOptions.${mapType.symbol}`);
                }
            })

            return mapTypes.sort((a, b) => a.priority - b.priority);
        },
        loadStandardMapTypes(operation) {
            switch (operation.operation_type) {
                case 'SEEDING':
                    return MAP_TYPES().SEEDING
                case 'HARVEST':
                    return MAP_TYPES().HARVEST
                case 'MOWING':
                    return MAP_TYPES().MOWING
                case 'TILLAGE':
                    return MAP_TYPES().TILLAGE
                case 'DRY_APPLICATION':
                    return MAP_TYPES().DRY_APPLICATION
                case 'LIQUID_APPLICATION':
                    return MAP_TYPES().LIQUID_APPLICATION
                case 'TRANSPORT':
                    return MAP_TYPES().TRANSPORT
            }
        },
        parseStatistics(builtStatistics, map) {
            if (map === 'one') {
                this.statisticsOne = builtStatistics.statistics
                this.operatorsOne = builtStatistics.operators
                this.vehiclesOne = builtStatistics.vehicles
                this.varietiesOne = builtStatistics.varieties
                this.productsOne = builtStatistics.products
                return
            }

            this.statisticsTwo = builtStatistics.statistics
            this.operatorsTwo = builtStatistics.operators
            this.vehiclesTwo = builtStatistics.vehicles
            this.varietiesTwo = builtStatistics.varieties
            this.productsTwo = builtStatistics.products
        },
        initGetOperationMapOne() {
            this.centerMap = this.previousMapEmptyOne
            this.getFileNameOne()
        },
        initGetOperationMapTwo() {
            this.centerMap = this.previousMapEmptyOne
            this.getFileNameTwo()
        }
    },
    computed: {
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        }
    },
    props: {
        operationOne: {
            type: Object
        },
        mapTypeOne: {
            type: Object
        },
        operationTwo: {
            type: Object
        },
        mapTypeTwo: {
            type: Object
        },
        fieldCenter: {
            type: Object
        },
        selectedField: {
            type: Object
        }
    },
    watch: {
        operationOne: function () {
            this.previousMapEmptyOne = true;
            this.clearData('one');
            this.getStatistics(this.operationOne, 'one');
        },
        mapTypeOne: function () {
            if (!this.mapTypeOne) {
                return;
            }
            this.initGetOperationMapOne();
        },
        operationTwo: function () {
            this.clearData('two');
            this.getStatistics(this.operationTwo, 'two');
        },
        mapTypeTwo: function () {
            if (!this.mapTypeTwo) {
                return;
            }
            this.initGetOperationMapTwo();
        }
    },
    components: {
        Splitpanes,
        Pane,
        AppOperationsStats,
        AppGoogleMapsOperations,
        AppGoogleMapsTypeControl,
        AppOperationsWorkOptions,
        AppOperationsRateStepsEditDialog,
        AppOperationsStatsSkeleton
    }
}

</script>

<style scoped lang="scss">
@import "src/assets/styles/constants";

.splitpanes.default-theme .splitpanes__pane {
    background-color: #fff;
}

.splitpanes__pane.stats {
    overflow-y: auto;
}

.splitpanes__pane.stats::-webkit-scrollbar {
    width: 10px;
}

.splitpanes__pane.stats::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(98, 95, 95, 0.8);
}

.splitpanes__pane.stats::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 2px rgba(98, 95, 95, 0.7);
}

.splitpanes__pane.stats::-webkit-scrollbar-thumb:hover {
    -webkit-box-shadow: inset 0 0 5px rgba(98, 95, 95, 0.7);
}

</style>
